import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { VAM_SERVICE } from '@eggplant/api-hosts'
import type { GetTestCasesParams } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  assetId: string
  params: GetTestCasesParams
  children?: (data: string[]) => ReactElement
}

const GetSuiteFeaturesRequest = ({
  assetId,
  params,
  children
}: Props) => {
  const url = `${VAM_SERVICE}/suites/${assetId}/features`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      params={params}
      url={url}
    />
  )
}

export default GetSuiteFeaturesRequest
